import React from 'react';

import styles from './HamburgerIcon.module.scss'

const HamburgerIcon = ({onClick, opened, className = ''}) => {
    return (
		<div onClick={onClick} className={`${styles.hamburger} ${className}`}>
			<svg id="hamburger" className={`${styles.hamburger} ${opened ? styles.opened : styles.closed}`} viewBox="0 0 60 40">
				<g stroke="#333" stroke-width="4" stroke-linecap="round" strokeLinejoin="round">
					<path className={styles.topLine} d="M10,10 L50,10 Z"></path>
					<path className={styles.middleLine} d="M10,20 L50,20 Z"></path>
					<path className={styles.bottomLine} d="M10,30 L50,30 Z"></path>
				</g>
			</svg>
		</div>
    )
}

export default HamburgerIcon;